/**
 * Navigation clicks vs clicks on the page itself.
 *
 * A sticky or scrolling navbar collects clicks on every page (Pricing, Product,
 * the logo), so a page's click count mixes "moved around the site" with
 * "acted on this page". The tracker tags some elements `nav-link` in the click
 * details; the per-page breakdown carries only the element id, so ids that
 * start with nav-, navbar-, mobilenav-, menu- or header-nav- read as navigation
 * too. True detection (a fixed or sticky ancestor at click time) needs the
 * tracking script; until then this is a naming rule, not a guarantee.
 */

const NAV_TARGET = /^(nav|navbar|mobilenav|mobile-nav|site-nav|header-nav|main-nav|menu)([-_]|$)/i

export function isNavigationClick(target: string | null | undefined, secondary?: string | null): boolean {
  if (secondary === "nav-link") return true
  return NAV_TARGET.test(String(target ?? "").trim())
}

/** Share of clicks on navigation among the given targets, or null with no clicks. */
export function navigationShare(targets: { target: string; clicks: number; secondary?: string | null }[]): number | null {
  const total = targets.reduce((sum, t) => sum + (t.clicks || 0), 0)
  if (!(total > 0)) return null
  const nav = targets.reduce((sum, t) => (isNavigationClick(t.target, t.secondary) ? sum + (t.clicks || 0) : sum), 0)
  return nav / total
}
